import React from "react";
import { withRouter } from 'react-router-dom';
import { notifica, getUser, show_ldr, checkUser } from "../requests/utils";
import Horarios from "./Horarios/Horarios";
import { Button } from "react-md";
import { Dialog, DialogContent } from "@react-md/dialog";
import { ReplySVGIcon } from "react-md";
import {
  getDetalleVacante,
  GetPreguntasInicialesEntrevista,
  postPostularCandidato,
  postPostularCandidatoFormulario,
} from "../requests/req_ofertas";
import "../styles/Vacante.css";
import NoFound from "./NoFound";
import { FormularioPostulacion } from "./Vacante/FormularioPostulacion";
import {
  ButtonPostular,
  MainContainer,
  ButtonContainer,
  Container,
  ButtonContainerNormal,
  ButtonPostularNormal,
} from "./Vacante/styled.component";
import { InformaciónVacante } from "./Vacante/InformaciónVacante";
import { LoaderContainer } from "./Vacante/LoaderContainer";
import queryString from 'query-string';

class Vacante extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      Header: this.props.vacantes,
      tipomodal: null,
      datos: null,
      moduloModal: "",
      preguntas: [],
      nomBoton: "Hacer login y postular",
      postulado: false,
      puesto: this.props.puesto != null ? this.props.puesto : "",
      isVisible: false,
      loading: true,
      showLoginPostula: false,
      detallesS: null,
      horario: null,
      screenWidth: window.innerWidth,
      isCloseModal: false,
      qr: '',
      idSolicitud: 0,
      idZonificacion: 0,
      prestador: 0,
    };

    this.generaDvBg = this.generaDvBg.bind(this);
    this.generaDvSm = this.generaDvSm.bind(this);
    this.validaLogin = this.validaLogin.bind(this);
    this.detallevacante = this.detallevacante.bind(this);
    this.onChangePropsModal = this.onChangePropsModal.bind(this);
    this.onChangebtnsv = this.onChangebtnsv.bind(this);
    this.setPreguntas = this.setPreguntas.bind(this);
    this.postularse = this.postularse.bind(this);
    this.isOpenFormulario = this.isOpenFormulario.bind(this);
  }

  handleResize = () => {
    const { isCloseModal, screenWidth } = this.state;
    const isWideScreen = screenWidth >= 850;
    const sections = {
      information: document.querySelector(".order-one"),
      form: document.querySelector(".order-two"),
      openButton: document.querySelector(".open-button"),
      closeIcon: document.querySelector(".close-icon"),
      openInformation: document.querySelector(".open-information"),
    };

    this.setState({
      screenWidth: window.innerWidth,
    });

    const setDisplay = (element, display) => {
      if (element) {
        element.style.display = display;
      }
    };

    const setGrid = (element, styles) => {
      if (element) {
        element.style.gridTemplateColumns = styles;
      }
    };

    if (isWideScreen || !isCloseModal) {
      setDisplay(sections.openButton, isWideScreen ? "none" : "flex");
      setDisplay(sections.closeIcon, isWideScreen ? "none" : "flex");
      setDisplay(sections.form, isWideScreen ? "flex" : "none");
      setDisplay(sections.information, "flex");
      setGrid(sections.openInformation, isWideScreen ? "1fr 1fr" : "1fr");
      this.setState({
        isCloseModal: false,
      });
    }
  };

  componentDidMount() {
    window.addEventListener("resize", this.handleResize);

    //function to get qr
    let url = window.location.href;
    if (url != null) {
      let json = "";
      if (url.split("?").length > 1) {
        var key = queryString.parseUrl(url).query;

        if (key.vct != null) {
          localStorage.setItem("qr", key.vct);
          var encodedString = key.vct;
          var decodedString = atob(encodedString);

          if (decodedString !== "{}" && decodedString !== "") {
            json = JSON.parse(decodedString);
            this.setState({
              qr: json.applyTechnical,
              idSolicitud: json.idSolicitud,
              idZonificacion: json.idZonificacion
            })
          }
        }
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  componentDidUpdate(prevProps, prevState) {

    if (prevProps.idvac !== this.props.idvac) {
      setTimeout(() => {
        this.handleShow();
      }, 5000);
    }
  }
  hide = () => {
    if (this.props.vacantes === null) {
      show_ldr(true);
    }
    this.props.action(false);
    this.setState({ datos: null });
    this.setState({ loading: true });

    if (localStorage.getItem('qr')) {
      localStorage.removeItem('qr')
      this.setState({ isVisible: false }, () => window.location.replace(window.origin + "/ofertas"));
    }
  };
  postLogin() {
    GetPreguntasInicialesEntrevista(this.props.idvac, (x) =>
      this.setPreguntasw(x)
    );
  }
  setPreguntasw(datos) {
    var items = [],
      user = getUser();

    if (user !== undefined) {
      if (datos != null) {
        if (Array.isArray(datos)) {
          datos.forEach((item) => {
            var options = [];

            item.opciones.forEach((op) => {
              var x = {
                descripcion: op.descripcion,
                idPregunta: op.idPregunta,
                idSolicitud: op.idSolicitud,
                valor: op.valor,
                idCandidato: user.idCandidato,
                contestacion: op.contestacion,
                idRespuestaOpciones: op.valor,
                idUsuarioAct: 1,
              };
              options.push({ value: x, label: op.descripcion });
            });
            var i = {
              pregunta: item.pregunta,
              tipo: "Combo",
              options: options,
            };
            items.push(i);
          });
        }
      }
    }
    if (items.length > 0) {
      this.setState(
        {
          moduloModal: "Preguntas",
          nomBoton: "Guardar",
          showLoginPostula: false,
          preguntas: items,
        },
        () => {
          document.getElementById("BtnMdl").click();
        }
      );
    } else {
      this.postularse();
    }
  }
  handleShow = () => {
    this.setState({ loading: true });
    GetPreguntasInicialesEntrevista(this.props.idvac, (x) =>
      this.setPreguntas(x)
    );

    getDetalleVacante((d) => this.detallevacante(d), this.props.idvac);
  };
  onChangePropsModal(modulo) {
    this.setState({ moduloModal: modulo });
  }
  onChangebtnsv(boton) {
    this.setState({ nomBoton: boton });
  }
  setPreguntas(datos) {
    var items = [],
      user = getUser();

    if (user !== undefined) {
      if (datos != null) {
        if (Array.isArray(datos)) {
          datos.forEach((item) => {
            var options = [];

            item.opciones.forEach((op) => {
              var x = {
                descripcion: op.descripcion,
                idPregunta: op.idPregunta,
                idSolicitud: op.idSolicitud,
                valor: op.valor,
                idCandidato: user.idCandidato,
                contestacion: op.contestacion,
                idRespuestaOpciones: op.valor,
                idUsuarioAct: 1,
              };
              options.push({ value: x, label: op.descripcion });
            });
            var i = {
              pregunta: item.pregunta,
              tipo: "Combo",
              options: options,
            };
            items.push(i);
          });
        }
      }
    }

    this.setState({ preguntas: items });
  }
  detallevacante(datos) {
    if (datos.solicitudes.length === 0)
      return notifica("warning", "No hay detalle de la solicitud", "");
    var puesto =
      datos.solicitudes[0].puesto !== undefined
        ? datos.solicitudes[0].puesto
        : "";
    this.setState({ puesto: puesto });

    let h = datos.horariosSolicitud;
    this.setState({ loading: false });
    if (datos.solicitudes.length === 0) {
      return notifica("warning", "No hay detalle de la solicitud", "");
    }
    var dat = {
      data: datos.solicitudes,
    };

    this.setState({
      datos: dat,
      postulado: datos.valiadacion[0].postulado === 1 ? true : false,
    });

    if (Object.keys(datos).length > 0) {
      this.setState(
        { detallesS: datos.solicitudes, horario: h, prestador: datos.solicitudes[0].idPrestador },
        () => {
          this.setState({ loading: false });
        }
      );
    } else {
      this.setState({ loading: false }, () => {
        notifica("warning", "No hay detalle de la solicitud", "");
      });
    }
  }
  generaDvBg(datos, horario) {
    let arr_sec = [];
    datos.forEach(function (d) {
      const cd = arr_sec.filter((c) => c.seccion === d.descrCategoria);
      if (cd.length === 0) {
        arr_sec.push({ seccion: d.descrCategoria });
      }
    });

    return arr_sec.map((s, index) => {
      const cat = s.seccion.split("-");
      return (
        <div key={index} className="dv_secciones">
          <label key={index} className="lbl_blk" style={{ padding: "0 20px" }}>
            {cat[0]}
          </label>
          {this.generaDvSm(
            datos.filter((d) => d.descrCategoria === s.seccion),
            cat[0],
            horario
          )}
        </div>
      );
    });
  }
  generaDvSm(datos, seccion, horario) {
    return datos.map((a, index) => {
      if (horario !== undefined) {
        if (horario.length !== 0) {
          if (a.descPRegunta === "Días y horario de trabajo") {
            return <Horarios datosprev={horario} />;
          } else if (a.descPRegunta === "Horarios de trabajo") {
            return null;
          }
        }
      }

      return (
        <div key={index}>
          <ul style={{ padding: "0 20px" }}>
            <li style={{ listStyle: "none" }}>
              <label
                key={index}
                className="lbl_md_bl"
                style={{
                  marginRight: "10px",
                  overflowWrap: "break-word",
                  wordBreak: "break-word"
                }}
              >
                {a.descPRegunta + (a.descRespuesta === null ? "" : ":")}
              </label>
              <label style={{
                overflowWrap: "break-word",
                wordBreak: "break-word"
              }} >
                {(() => {
                  if (a.descRespuesta === null) return "";
                  if (a.descRespuesta === "true") return "SI";
                  if (a.descRespuesta === "false") return "NO";
                  return a.descRespuesta;
                })()}
              </label>
            </li>
          </ul>
        </div>
      );
    });
  }

  validaLogin(e) {
    var usr = getUser();
    if (usr !== undefined) {
      var elm = e.target;
      elm.classList.add("Hide_All");

      if (this.state.preguntas.length > 0) {
        this.setState({ moduloModal: "Preguntas", nomBoton: "Guardar" }, () => {
          document.getElementById("BtnMdl").click();
        });
      } else {
        this.setState({ isVisible: true });
        var div1 = document.getElementById("img");
        if (div1) div1.style.display = "block";
        this.postularse();
      }
    } else {
      this.setState({ showLoginPostula: true });
    }
  }

  validaLoginPreg(e) {
    var usr = getUser();
    if (usr !== undefined) {
      GetPreguntasInicialesEntrevista(this.props.idvac, (x) =>
        this.setPreguntas(x)
      );
      var elm = e.target;
      elm.classList.add("Hide_All");

      if (this.state.preguntas.length > 0) {
        this.setState({ moduloModal: "Preguntas", nomBoton: "Guardar" }, () => {
          document.getElementById("BtnMdl").click();
        });
      } else {
        var div1 = document.getElementById("img");
        div1.style.display = "block";
        this.postularse();
      }
    } else {
      //Se manda a llamar el modal para hacer Login
      this.setState({ showLoginPostula: true });
    }
  }

  isOpenFormulario(e) {
    let isCloseModal = this.state.isCloseModal;

    let isDisplayFormulario = document.getElementsByClassName("order-two")[0];
    let isDisplayInformacion = document.getElementsByClassName("order-one")[0];
    let isButtonContainer = document.getElementsByClassName("open-button")[0];
    let isCloseIcon = document.getElementsByClassName("close-icon")[0];

    if (isCloseModal === false) {
      isButtonContainer.style.display = "none";
      isCloseIcon.style.display = "flex";
      isDisplayFormulario.style.display = "flex";
      isDisplayInformacion.style.display = "none";
      //Regresa a su estado normal
      this.setState({
        isCloseModal: true,
      });
    } else {
      isButtonContainer.style.display = "flex";
      isCloseIcon.style.display = "none";
      isDisplayFormulario.style.display = "none";
      isDisplayInformacion.style.display = "flex";
      this.setState({
        isCloseModal: false,
      });
    }
  }

  async postularse(data = {}) {
    let request;
    if (data._name?.length > 0) {
      request = await postPostularCandidatoFormulario(data, this.state.idSolicitud, this.state.idZonificacion);
    } else {
      request = await postPostularCandidato();
    }

    const cv = window.origin + "/perfil";
    if (data._name) {
      if (Object.keys(request).length > 0) {
        localStorage.removeItem("qr");
        localStorage.removeItem("vct");
        this.hide();
        this.setState({ isVisible: false }, () => window.location.replace(window.origin + "/ofertas"));
      }
    } else {
      if (Object.keys(request).length > 0) {
        let div1 = document.getElementById("img");
        div1.style.display = "none";
        localStorage.removeItem("vct");
        this.setState({ isVisible: false }, () => window.location.replace(cv));
      } else {
        let div = document.getElementById("img");
        if (div) {
          div.style.display = "none";
        }
        this.setState({ isVisible: false });
        this.hide();
      }
    }
  }

  render() {
    var imgn = window.location.origin + "/images/logos/";
    const { loading, detallesS, horario } = this.state;
    let styleBody = {
      box1: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
      },
    };

    return (
      <div className=".rmd-dialog-overlay">
        <Dialog visible={this.props.mostrar} onRequestClose={() => { }}>
          <DialogContent
            id="navigation-drawer-demo"
            aria-label="Navigation Drawer Demo"
            focusOnMount={false}
            onShow={this.handleShow}
            onHide={this.hide}
          >
            <div className="Ofrt_Hdr_Vcnt">
              <div className="dv_sm">
                <Button
                  id="exit"
                  floating
                  primary
                  iconChildren="reply"
                  onClick={this.hide}
                >

                  <ReplySVGIcon style={{ color: 'white' }} />
                </Button>
              </div>
              <div className="dv_sm"></div>
            </div>
            <Container >
              {!loading ? (
                this.state.datos === null ? (
                  <NoFound></NoFound>
                ) : (
                  <MainContainer className="open-information" qr={this.state.qr}>

                    <div className="full-width order-one">
                      <InformaciónVacante _this={this} detallesS={detallesS} horario={horario} prestador={this.state.prestador} />
                    </div>

                    {this.state?.qr === false ?
                      <div className="full-width order-two">{
                        console.log(checkUser())
                      }
                        {
                          checkUser() ?
                            <div className="postulation-complete">
                              <div id="img" style={{ display: "none" }}>
                                <svg
                                  className="imgLoad"
                                  viewBox="0 0 135 135"
                                  xmlns="http://www.w3.org/2000/svg"
                                  fill="#F5A796"
                                >
                                  <path
                                    d="M67.447 58c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10zm9.448 9.447c0 5.523 4.477 10 10 10 5.522 0 10-4.477 10-10s-4.478-10-10-10c-5.523 0-10 4.477-10 10zm-9.448 9.448c-5.523 0-10 4.477-10 10 0 5.522 4.477 10 10 10s10-4.478 10-10c0-5.523-4.477-10-10-10zM58 67.447c0-5.523-4.477-10-10-10s-10 4.477-10 10 4.477 10 10 10 10-4.477 10-10z"
                                    transform="rotate(-24.1962 67 67)"
                                  >
                                    <animateTransform
                                      attributeName="transform"
                                      type="rotate"
                                      from="0 67 67"
                                      to="-360 67 67"
                                      dur="2.5s"
                                      repeatCount="indefinite"
                                    ></animateTransform>
                                  </path>
                                  <path
                                    d="M28.19 40.31c6.627 0 12-5.374 12-12 0-6.628-5.373-12-12-12-6.628 0-12 5.372-12 12 0 6.626 5.372 12 12 12zm30.72-19.825c4.686 4.687 12.284 4.687 16.97 0 4.686-4.686 4.686-12.284 0-16.97-4.686-4.687-12.284-4.687-16.97 0-4.687 4.686-4.687 12.284 0 16.97zm35.74 7.705c0 6.627 5.37 12 12 12 6.626 0 12-5.373 12-12 0-6.628-5.374-12-12-12-6.63 0-12 5.372-12 12zm19.822 30.72c-4.686 4.686-4.686 12.284 0 16.97 4.687 4.686 12.285 4.686 16.97 0 4.687-4.686 4.687-12.284 0-16.97-4.685-4.687-12.283-4.687-16.97 0zm-7.704 35.74c-6.627 0-12 5.37-12 12 0 6.626 5.373 12 12 12s12-5.374 12-12c0-6.63-5.373-12-12-12zm-30.72 19.822c-4.686-4.686-12.284-4.686-16.97 0-4.686 4.687-4.686 12.285 0 16.97 4.686 4.687 12.284 4.687 16.97 0 4.687-4.685 4.687-12.283 0-16.97zm-35.74-7.704c0-6.627-5.372-12-12-12-6.626 0-12 5.373-12 12s5.374 12 12 12c6.628 0 12-5.373 12-12zm-19.823-30.72c4.687-4.686 4.687-12.284 0-16.97-4.686-4.686-12.284-4.686-16.97 0-4.687 4.686-4.687 12.284 0 16.97 4.686 4.687 12.284 4.687 16.97 0z"
                                    transform="rotate(300.061 67 67)"
                                  >
                                    <animateTransform
                                      attributeName="transform"
                                      type="rotate"
                                      from="0 67 67"
                                      to="360 67 67"
                                      dur="8s"
                                      repeatCount="indefinite"
                                    ></animateTransform>
                                  </path>
                                </svg>
                              </div>
                              {
                                this.state.postulado
                                  ? "Ya te has postulado"
                                  : <ButtonContainerNormal className="open-login">
                                    <ButtonPostularNormal onClick={(e) => this.validaLogin(e)}>
                                      Postular ahora
                                    </ButtonPostularNormal>
                                  </ButtonContainerNormal>
                              }
                            </div> : <FormularioPostulacion _this={this} />
                        }

                      </div>
                      :
                      <div className="postulation-complete">
                        <div id="img" style={{ display: "none" }}>
                          <svg
                            className="imgLoad"
                            viewBox="0 0 135 135"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="#F5A796"
                          >
                            <path
                              d="M67.447 58c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10zm9.448 9.447c0 5.523 4.477 10 10 10 5.522 0 10-4.477 10-10s-4.478-10-10-10c-5.523 0-10 4.477-10 10zm-9.448 9.448c-5.523 0-10 4.477-10 10 0 5.522 4.477 10 10 10s10-4.478 10-10c0-5.523-4.477-10-10-10zM58 67.447c0-5.523-4.477-10-10-10s-10 4.477-10 10 4.477 10 10 10 10-4.477 10-10z"
                              transform="rotate(-24.1962 67 67)"
                            >
                              <animateTransform
                                attributeName="transform"
                                type="rotate"
                                from="0 67 67"
                                to="-360 67 67"
                                dur="2.5s"
                                repeatCount="indefinite"
                              ></animateTransform>
                            </path>
                            <path
                              d="M28.19 40.31c6.627 0 12-5.374 12-12 0-6.628-5.373-12-12-12-6.628 0-12 5.372-12 12 0 6.626 5.372 12 12 12zm30.72-19.825c4.686 4.687 12.284 4.687 16.97 0 4.686-4.686 4.686-12.284 0-16.97-4.686-4.687-12.284-4.687-16.97 0-4.687 4.686-4.687 12.284 0 16.97zm35.74 7.705c0 6.627 5.37 12 12 12 6.626 0 12-5.373 12-12 0-6.628-5.374-12-12-12-6.63 0-12 5.372-12 12zm19.822 30.72c-4.686 4.686-4.686 12.284 0 16.97 4.687 4.686 12.285 4.686 16.97 0 4.687-4.686 4.687-12.284 0-16.97-4.685-4.687-12.283-4.687-16.97 0zm-7.704 35.74c-6.627 0-12 5.37-12 12 0 6.626 5.373 12 12 12s12-5.374 12-12c0-6.63-5.373-12-12-12zm-30.72 19.822c-4.686-4.686-12.284-4.686-16.97 0-4.686 4.687-4.686 12.285 0 16.97 4.686 4.687 12.284 4.687 16.97 0 4.687-4.685 4.687-12.283 0-16.97zm-35.74-7.704c0-6.627-5.372-12-12-12-6.626 0-12 5.373-12 12s5.374 12 12 12c6.628 0 12-5.373 12-12zm-19.823-30.72c4.687-4.686 4.687-12.284 0-16.97-4.686-4.686-12.284-4.686-16.97 0-4.687 4.686-4.687 12.284 0 16.97 4.686 4.687 12.284 4.687 16.97 0z"
                              transform="rotate(300.061 67 67)"
                            >
                              <animateTransform
                                attributeName="transform"
                                type="rotate"
                                from="0 67 67"
                                to="360 67 67"
                                dur="8s"
                                repeatCount="indefinite"
                              ></animateTransform>
                            </path>
                          </svg>
                        </div>
                        {
                          this.state.postulado
                            ? "Ya te has postulado"
                            : <ButtonContainerNormal className="open-login">
                              <ButtonPostularNormal onClick={(e) => this.validaLogin(e)}>
                                Postular ahora
                              </ButtonPostularNormal>
                            </ButtonContainerNormal>
                        }
                      </div>
                    }
                    {this.state?.qr === false ?
                      <ButtonContainer className="open-button">
                        <ButtonPostular onClick={(e) => this.isOpenFormulario(e)}>
                          Postularme
                        </ButtonPostular>
                      </ButtonContainer> :
                      this.state.postulado ?
                        "Ya te has postulado"
                        :
                        <ButtonContainer className="open-button">
                          <ButtonPostular onClick={(e) => this.validaLogin(e)}>
                            Postular ahora
                          </ButtonPostular>
                        </ButtonContainer>}

                  </MainContainer>
                )
              ) : (
                <LoaderContainer />
              )}
            </Container>
          </DialogContent >
        </Dialog >
      </div>
    );

  }
}
export default withRouter(Vacante);
